const Billing = () => {}

export default Billing